<template>
    <section class="comp_guests_home">
        <div class="comp_scroller">
            <div class="comp_content">
                <header
                    class="wrp_comp_header mod--row mod--row-flex mod--row-middle mod--flex-column"
                    style="border-bottom: none; margin-bottom: 0; display:flex">
                    <div style="display:flex">
                        <div class="col">
                            <div
                                :class="`mod--row mod--row-flex mod--row-middle hideable ${(!isToday() || searchActive)?'hidden':''}`">
                                <div :class="`col`">
                                    <h1 class="part_ui_heading" v-bind:class="{'mod--hidden':searchActive}">
                                <span>{{ $t('current_guests') }}: {{ currentRoomsCount }} / {{
                                        currentGuestsCount
                                    }}</span>
                                    </h1>
                                </div>
                            </div>
                            <div
                                :class="`mod--row mod--row-flex mod--row-middle hideable ${(!isToday() || searchActive)?'hidden':''}`"
                                style="border-bottom: none; margin-bottom: 0">
                                <div class="col">
                                    <h2 class="part_ui_heading mod--subtitle"
                                        v-bind:class="{'mod--hidden':searchActive}">
                                <span>
                                    {{ $t('expected_guests') }}: {{ expectedRoomsCount }} / {{ expectedGuestsCount }}
                                </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <form
                            :class="`col mod--flex-grow col--search mod--right ${(isToday() && !searchActive)?'vertical-buttons':''}`"
                            v-on:submit="doSearch"
                            style="min-height: 43px;position: relative;display: flex;justify-content: flex-end;;margin-bottom: 8px">
                            <input ref="search" type="text" v-model="search" :placeholder="$t('search')"
                                   v-bind:class="{'mod--active':searchActive}">
                            <button class="icon icon--search" style="margin-right: 8px;height: 43px"></button>
                            <a class="help" v-on:click.prevent="showPopup(8233720174237)"
                               style="display:block;align-self: center; margin-left: 12px">
                                <i class="icon icon--question-circle-fill"/>
                            </a>
                        </form>
                    </div>
                </header>
                <DateInputHeader v-model="date"/>
                <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']"
                     v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4">
                        <template v-if="guests.length > 0">
                            <div class="col col--12" v-for="roomId in Object.keys(guestsGrouped)">
                                <part-guest-group v-bind:guests="guestsGrouped[roomId]"
                                                  :roomId="roomId"
                                                  :showDetailOnClick="true"/>
                            </div>
                            <div class="col col--12">
                                <part-guest-group v-bind:guests="[guest]"
                                                  v-for="guest in ungroupedGuests"
                                                  :key="guest.id"
                                                  :roomId="guest.currentRoomId"
                                                  :showDetailOnClick="true"/>
                            </div>
                        </template>
                        <div class="col col--12" v-else>
                            <p>{{ $t('nothing_found') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateInputHeader from '../part/item/date_input_header';
import {fetchZenDesk, sanitize} from '../../main';

export default {
    name: 'guests-home',
    components: {DateInputHeader},
    data() {
        return {
            loading: false,
            guests: [],
            guestsGrouped: {},
            ungroupedGuests: [],
            search: '',
            searchActive: false,
            date: new Date(),
            currentRoomsCount: null,
            currentGuestsCount: null,
            expectedRoomsCount: null,
            expectedGuestsCount: null
        }
    },
    created() {
        this.getGuests();
    },
    watch: {
        date: function () {
            this.getGuests()
        }
    },
    methods: {
        doSearch: function (e) {
            e.preventDefault();
            if (this.searchActive === false) {
                this.searchActive = true;
                this.$nextTick(() => this.$refs.search.focus());
            } else {
                this.getGuests();
            }
        },
        changeDate: function () {
            this.getGuests();
        },
        getGuests: function () {
            this.loading = true;

            let dateFilter = '';

            if (this.date) {
                dateFilter = ', check_in_date: ":' + moment(this.date).format('YYYY-MM-DD') + '", check_out_date: "' + moment(this.date).format('YYYY-MM-DD') + ':"';
            }

            let query = `{
                    listCurrentGuestInfo(search_anywhere: "%${sanitize(this.search)}%"${dateFilter})
                    {
                        id,
                        first_name,
                        last_name,
                        check_in_date,
                        check_out_date,
                        group_name,
                        current_room_id,
                        room_code,
                        room_type_code,
                        reservation_number,
                        reservation_guest_id
                        current_room_id,
                        current_account_id
                    }
                    basicInfo {
                      occupied_room_count,
                      current_guest_count,
                      check_out_guest_count,
                      current_room_count,
                      check_out_room_count,
                      total_guests_count
                    }
                }`;

            axios({
                data: query
            }).then(response => {
                let guests = [];
                let guestsGrouped = [];
                let ungroupedGuests = [];
                this.loading = false;

                const basicInfo = response.data.data.basicInfo;

                response.data.data.listCurrentGuestInfo.forEach(function (item) {
                    let guest = {};
                    guest.id = item.reservation_number;
                    guest.row = item.reservation_guest_id;
                    guest.currentRoomId = item.current_room_id;
                    guest.room = item.room_type_code;
                    guest.room_code = item.room_code;
                    guest.checkin_date = moment(item.check_in_date).format('D. M.');
                    guest.checkout_date = moment(item.check_out_date).format('D. M.');
                    guest.icons = [];
                    guest.group = item.group_name;
                    guest.full_name = item.first_name + ' ' + item.last_name;
                    guest.current_account_id = item.current_account_id
                    guests.push(guest);

                    const group = Number.isInteger(item.current_room_id) ? item.current_room_id.toString() : undefined
                    if (group) {
                        if (!guestsGrouped[group]) {
                            guestsGrouped[group] = []
                        }
                        guestsGrouped[group].push(guest)
                    } else {
                        ungroupedGuests.push(guest)
                    }
                });

                this.guests = guests;
                this.guestsGrouped = guestsGrouped;
                this.ungroupedGuests = ungroupedGuests;

                this.currentRoomsCount = basicInfo.current_room_count + basicInfo.check_out_room_count;
                this.currentGuestsCount = basicInfo.current_guest_count + basicInfo.check_out_guest_count;
                this.expectedRoomsCount = basicInfo.occupied_room_count
                this.expectedGuestsCount = basicInfo.total_guests_count
            }).catch(error => {
                this.showError(error)
            });
        },
        isToday: function () {
            return moment(this.date).isSame(moment(), 'day')
        },
        showPopup(articleId) { // FIXME udělat jako samostatnou komponentu a zobecnit i další prvky této obrazovky s ostatními
            fetchZenDesk(articleId)
                .then(article => {
                    let title;
                    let body;
                    if (article === 'not-found') {
                        title = 'Article not found'
                        body = 'Help is available for Czech or English. To display the help, change the language of the application in the settings.'
                    } else {
                        title = article.title
                        body = article.body
                    }

                    // FIXME udělat pořádně
                    const el = document.getElementById('popup');
                    el.innerHTML = '<div class=\'hint\'>' +
                        '<h2>' + title + '</h2>' +
                        body
                        +
                        '<button onclick=\'document.getElementById("popup").classList.remove("visible")\' class=\'close\'><span class="icon icon--x-circle-fill"></span></button>' +
                        '</div>'
                    el.classList.add('visible')
                })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/guests-home.vue